import { ReceiptLineProductComponent } from './receipt-line-product.component';

export default angular
  .module('sfMobile.components.receipt-line-product', [])
  .component('sfReceiptLineProduct', ReceiptLineProductComponent).name;
